import React from "react"
import { Link } from "gatsby"
import { useLocation } from '@reach/router'

import QRCodeModalButton from "../qrcodeModal/qrcodeModalButton.js";
import { QRCodeModalConsumer } from "../qrcodeModal/qrcodeModalContext.js";

import styles from "./headerNav.module.scss"

const HeaderNav = ({ navExpanded, showCTA }) => {
  const location = useLocation();
  const { search } = location;

  return (
    <QRCodeModalConsumer>
      {() => {
        let rootClasses = [styles.root]
       
          if(!showCTA){
            rootClasses = rootClasses.concat(styles.rootExtraNarrow)
          }else{
            rootClasses = rootClasses.concat(styles.rootNarrow)
          }
          
        let listRootClasses = [styles.listRoot]
        if (navExpanded) {
          listRootClasses = listRootClasses.concat(styles.listRootExpanded)
        }
        if (!showCTA) {
          listRootClasses = listRootClasses.concat(styles.rootExtraNarrow)
        }
        listRootClasses = listRootClasses.concat(styles.listRootWithCta)
       
        return (
          <nav className={rootClasses.join(' ')} aria-labelledby="mainmenulabel">
            <h2 id="mainmenulabel" style={{"visibility":"hidden","height":"0", "margin":"0", "padding":"0"}}>Main Menu</h2>
            <ul className={listRootClasses.join(' ')}>
              <li className={styles.listItem}>
                <Link to={`/about/${search}`}>
                  About Us
                </Link>
              </li>
              <li className={styles.listItem}>
                <Link to={`/blog/${search}`}>
                  Blog
                </Link>
              </li>
              <li className={styles.listItem}>
                <Link to={`/press/${search}`}>
                  Press
                </Link>
              </li>
              <li className={styles.listItem}>
                <Link to={`/faq/${search}`}>
                  FAQ
                </Link>
              </li>
              {showCTA &&
                <li className={styles.listItem}>
                    <div style={{ height: 60, display: "flex", alignItems: "center", width: 250 }}>
                      <QRCodeModalButton eventLabel="Header" />
                    </div>
                </li>
              }
            </ul>
          </nav>
        )
      }}
    </QRCodeModalConsumer>
  )
}

HeaderNav.defaultProps = {
  showCTA: true,
}

export default HeaderNav
